import React from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import discountImage from "../assets/disc.jpg";

const DiscountPopup = ({ open, onClose, imageUrl, bannerUrl }) => {
  const history = useHistory();

  const resolvedImage = imageUrl || discountImage;

  const handleViewSale = () => {
    onClose();
    if (bannerUrl) {
      if (bannerUrl.startsWith("http")) {
        window.location.assign(bannerUrl);
      } else {
        history.push(bannerUrl);
      }
    } else {
      history.push("/");
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            width: "100%",
            maxWidth: { xs: "95vw", sm: 480 },
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            padding: 0,
          },
        }}
        slotProps={{ backdrop: { sx: { backgroundColor: "rgba(0,0,0,0.6)" } } }}
      >
        <DialogContent
          sx={{
            p: 0,
            px: 0,
            position: "relative",
            overflow: "hidden",
            overflowY: "hidden",
            display: "flex",
            flexDirection: "column",
            "&.MuiDialogContent-root": { overflow: "hidden", padding: 0 },
          }}
        >
          <button
            type="button"
            onClick={handleViewSale}
            className="absolute left-3 sm:left-6 top-3 sm:top-4 z-[1] inline-flex items-center gap-1 text-red-600 hover:text-red-700 font-bold text-sm sm:text-base underline underline-offset-2"
          >
            View Sale
          </button>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 6,
              top: 6,
              zIndex: 1,
              color: "gray",
              bgcolor: "rgba(255,255,255,0.95)",
              "&:hover": { bgcolor: "white" },
              width: 32,
              height: 32,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <div
            role="button"
            tabIndex={0}
            onClick={handleViewSale}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleViewSale(); }}
            className="relative flex flex-col min-h-0 flex-1 overflow-hidden w-full cursor-pointer"
          >
            <img
              src={resolvedImage}
              alt="Discount offer"
              className="w-full h-auto block object-contain max-h-[70vh] object-center pointer-events-none"
              style={{ objectFit: "contain" }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DiscountPopup;
